import { Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { PaymentSuccess } from "./pages/PaymentSuccess";
import { PaymentFailed } from "./pages/PaymentFailed";
import { ProductDetail } from "./pages/ProductDetail";
import { Cart } from "./pages/Cart";
import { Checkout } from "./pages/Checkout";
import { NotFound } from "./pages/NotFound";
import { Favorites } from "./pages/Favorites";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { OrderTracking } from "./pages/OrderTracking";
import { FAQ } from "./pages/FAQ";
import { Account } from "./pages/Account";
import { LegalPage } from "./pages/LegalPage";
import { Explore } from "./pages/Explore";
import { CategoryPage } from "./pages/CategoryPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/urun/:id" element={<ProductDetail />} />
      <Route path="/kategori/:slug" element={<CategoryPage />} />
      <Route path="/sepet" element={<Cart />} />
      <Route path="/favoriler" element={<Favorites />} />
      <Route path="/hakkimizda" element={<About />} />
      <Route path="/iletisim" element={<Contact />} />
      <Route path="/siparis-takip" element={<OrderTracking />} />
      <Route path="/sss" element={<FAQ />} />
      <Route path="/hesabim" element={<Account />} />
      <Route path="/odeme" element={<Checkout />} />
      <Route path="/odeme-basarili" element={<PaymentSuccess />} />
      <Route path="/odeme-basarisiz" element={<PaymentFailed />} />
      <Route path="/yasal/:slug" element={<LegalPage />} />
      <Route path="/kesfet" element={<Explore />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
